import React from 'react';

interface IProps {
  handleClose: () => void;
  type?:'button' | 'submit' | 'reset' | undefined;
  text1?:string;
  text2?:string;
  handleAction?:() => void;
}

export function Footer ({handleClose, text1 = "salvar",text2= "sair", type ="button", handleAction}:IProps) {
  return (
    <footer>
      <button type="button" onClick={handleClose}>{text2}</button>
      <button type={type} onClick={handleAction}>{text1}</button>
    </footer>
  )
}